import { ArrowDownIcon, UserIcon } from 'cokitchen-icons';
import { OrderDetailCalculatedOrderType } from 'models/order.model';
import React, { useState } from 'react';
import { formatCurrency, getItemsTotal } from 'utils/functions';

type Props = {
  meal: OrderDetailCalculatedOrderType;
};
const GroupOrderMealAccordion = ({ meal }: Props) => {
  const [show, setShow] = useState(false);
  return (
    <div className='w-full bg-white mb-2'>
      <div
        className='w-full bg-[#F7F7F7] flex pt-4 justify-between px-[18px] items-center pb-4 border-b-[1px] cursor-pointer border-b-[#EAEBEB]'
        onClick={() => setShow(!show)}>
        <div className='flex gap-3 items-center'>
          <div className='w-10 h-10 flex justify-center items-center bg-white rounded-full'>
            <UserIcon />
          </div>
          <div>
            <p className='font-medium text-sm'>{meal.user?.first_name}</p>
            <p className='text-xs text-[#6F7376]'>
              {meal?.brand_ids?.length || 0} brands,
              {Array.isArray(meal?.meals) ? getItemsTotal(meal?.meals) : 0} items
            </p>
          </div>
        </div>
        <div className='flex gap-4 items-center'>
          <p>{formatCurrency(Number(meal.total_amount))}</p>
          <div className='w-[30px] h-[30px] rounded-full cursor-pointer bg-white flex justify-center items-center text-red-5'>
            {show ? <ArrowDownIcon className='transform rotate-180' /> : <ArrowDownIcon />}
          </div>
        </div>
      </div>
      {show && (
        <div className='w-full pt-2'>
          {meal?.meals.map((meal, index) => (
            <ul key={index}>
              {meal.meals?.map((meal, index) => (
                <li className='py-4 px-[18px] border-b-[0.8px] border-b-[#EAEBEB]' key={index}>
                  <div className='w-full flex items-center gap-4 mb-1'>
                    <p className='text-sm text-red-5 font-medium'>{meal.quantity}x</p>

                    <article className='flex flex-col gap-[3px]'>
                      <p className='text-sm font-medium leading-[21px]'>{meal.name}</p>
                      <ul>
                        {meal.addons?.map((addon) => (
                          <li key={addon.id} className='text-sm text-[#6F7376] leading-[22.4px]'>
                            {addon.quantity}x&nbsp;{addon?.meal_data?.name}
                          </li>
                        ))}
                      </ul>
                    </article>

                    <div className='flex items-center gap-[10px] font-medium ml-auto'>
                      <p>{formatCurrency(meal.amount)}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ))}
        </div>
      )}
    </div>
  );
};

export default GroupOrderMealAccordion;
